import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {ExternalLinksLink, GameCodeLink, GleamcodeLink, OtherCollectionsLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const MoreGroup = (context: NavigationContext): AccordionLinkGroup => ({
    type: 'accordionLinkGroup',
    label: 'navigation.more',
    links: [
        GleamcodeLink(context),
        GameCodeLink(context),
        OtherCollectionsLink(context),
        ExternalLinksLink(context)
    ],
    icon: 'navigation-group__more',
});

